import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface PVUnit {
  kwp: string
  comissioning: string
  globalRadiation: string
  powerGeneration: string
  unitType: string | null
  feedInRenumeration: string | null
  orientation: string
}

export interface GeneralInformation {
  pvUnits: PVUnit[]
  totalConsumptionInKwh: string
  pvLocationPostalCode: string
}

export interface GeneralInformationState {
  generalInformation: GeneralInformation
}

export const initialState: GeneralInformationState = {
  generalInformation: {
    pvUnits: [],
    totalConsumptionInKwh: '',
    pvLocationPostalCode: ''
  }
}

export const generalInformationSlice = createSlice({
  name: 'generalInformation',
  initialState,
  reducers: {
    setGeneralInformation: (state, action: PayloadAction<GeneralInformation>) => {
      state.generalInformation = action.payload
    }
  }
})

export const { setGeneralInformation } = generalInformationSlice.actions

export default generalInformationSlice.reducer
